import type { PublicPluginAPI, OptionalPlugin } from '@atlaskit/editor-common/types';
import type { AnalyticsPlugin } from '@atlaskit/editor-plugin-analytics';
import type { MalleableUiPlugin } from '@atlassian/editor-plugin-malleable-ui';
import type { ConfluenceUpdateDynamicUiOnPageData } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

export class DocumentDynamicUiUpdateCommandProcessor {
	constructor(
		private editorApi: PublicPluginAPI<[AnalyticsPlugin, OptionalPlugin<MalleableUiPlugin>]>,
	) {}

	streamChunk(
		data: ConfluenceUpdateDynamicUiOnPageData,
		isFinished: boolean,
		_traceId?: string,
		_singleInstrumentationId?: string,
	): void {
		if (isFinished) {
			this.editorApi.core.actions.execute(
				this.editorApi.malleableUi?.commands.replaceMauiApp({
					previousMauiId: data.previousMauiId,
					newMauiId: data.id,
				}),
			);
			return;
		}
	}
}
